import React, { memo, ReactElement } from "react";

export interface CloseIconProps {
    className?: string;
    onClick?: (e: React.MouseEvent) => void;
    size?: number;
    dataTestId?: string;
    stroke?: string;
    opacity?: string;
}
const CLOSE = "click here to close";

function CloseIcon(props: CloseIconProps): ReactElement {
    const { size = 12, className, onClick = (): null => null, dataTestId, opacity = "0.6", stroke = "#02060C" } = props;

    return (
        <button className={className} onClick={onClick} aria-label={CLOSE} data-testid={dataTestId}>
            <svg
                width={size}
                height={size}
                viewBox={`0 0 ${size} ${size}`}
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M1.75729 1.75736L5.99993 6M10.2426 10.2426L5.99993 6M5.99993 6L10.2426 1.75736M5.99993 6L1.75729 10.2426"
                    stroke={stroke}
                    strokeOpacity={opacity}
                    strokeWidth="2.25"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </button>
    );
}

export default memo(CloseIcon);
